import dayjs, { Dayjs } from 'dayjs'
import type { Timestamp, TimeWindowDto } from '~/model'
import { formatTime } from '~/helpers'

export namespace TimeWindowDtoUtil {
  export const equalsDate = (tw: TimeWindowDto, date: Dayjs | null) =>
    date && date.format('DD-MM-YYYY') === tw.deliveryDate

  export const containsDate = (tws: TimeWindowDto[], date: Dayjs | null) => tws.some((t) => equalsDate(t, date))

  export const equals = (tw1?: TimeWindowDto, tw2?: TimeWindowDto) =>
    tw1 && tw2 && tw1.startTime === tw2.startTime && tw1.endTime === tw2.endTime

  export const filterByDate = (tws: TimeWindowDto[], dateIso: Timestamp | undefined) =>
    dateIso
      ? tws
          .filter((tw) => tw.deliveryDate === dayjs(dateIso).format('DD-MM-YYYY'))
          .sort((tw1, tw2) => (tw1.startTime < tw2.startTime ? -1 : 1))
      : []

  export const format = (tw: TimeWindowDto) => `${formatTime(tw.startTime)} - ${formatTime(tw.endTime)}`

  export const isEveningTimeWindow = (tw: TimeWindowDto) => tw.startTime >= '1600'

  export const isSaterdayEveningTimeWindow = (tw: TimeWindowDto) =>
    isEveningTimeWindow(tw) && dayjs(tw.deliveryDate, 'DD-MM-YYYY').day() === 6
}
